import _ from 'lodash';
import { apiFetch, apiRemove } from '../utility';

const apiBase = 'fuelSubContract';

export const search = ({ parentFuelContractId, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.search`,
			params: { parentFuelContractId },
			dispatch,
			callback,
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			params,
			dispatch,
			callback,
		});
	};
};

export const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};

export const remove = ({ fuelSubContractId, callback = _.noop }) => {
	return (dispatch) => {
		apiRemove({
			base: apiBase,
			id: fuelSubContractId,
			dispatch,
			callback,
		});
	};
};
